import 'normalize.css';
import '@styles/global.scss';
import '@styles/fonts.scss';
import '@styles/prismjs.scss';

import sal from 'sal.js';

export const shouldUpdateScroll = ({ routerProps }) => {
  // Next line prevents gatsby scrolling to top when changing pages in pagination component
  if (routerProps.location.search?.includes('?page=')) return false;

  const preventScroll = routerProps.location.state?.preventScroll || null;
  document.body.parentNode.style.scrollBehavior = preventScroll ? 'auto' : 'smooth';

  return true;
};

export const onInitialClientRender = () => {
  sal();
}

export { default as wrapRootElement } from '@store/reduxWrapper';
